__turbopack_context__.v({
  "className": "inter_5802845b-module__9kuUBG__className",
  "variable": "inter_5802845b-module__9kuUBG__variable",
});
